import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

export function MobileAppBar({ children, open, setOpen }) {
  const brand = process.env.REACT_APP_BRAND || 'Analytics';
  const logo = require(`../../assets/${brand}/appicon.png`);
  return (
    <div
      style={{
        height: '100%,',
        top: 0,
        position: 'sticky',
        zIndex: 1000,
      }}
    >
      <AppBar color="default" position="sticky" style={{ zIndex: 1000 }}>
        <Toolbar>
          <IconButton edge="start" color="default" aria-label="menu" onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>
          <Typography color="textPrimary" variant="h6">
            <div>
              <img src={logo} alt={'Bup Icon'} className="analytics-header-logo" />
            </div>
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
        {children}
      </Drawer>
    </div>
  );
}
